/* Lagom theme: clouds module. Loads only when its section is on the page.
   Compositor-only: after the build, no JavaScript touches a cloud. Every cloud gets its own CSS @keyframes (drift back
   and forth in its lane, a slow breathing in scale and opacity), generated once from the seeded layout and written into
   one <style>; the browser's compositor runs them. Scroll parallax is a CSS scroll-driven animation
   (animation-timeline: view()) where the browser supports it; elsewhere the clouds keep drifting without parallax.
   Off-screen sections pause their animations. The look (positions, sizes, opacity, speeds) matches the old per-frame
   engine; the mouse parallax on fine pointers is gone (it needed a frame loop). */
(function () {
  'use strict';
  var L = window.Lagom; if (!L || !L.q) { return; }
  if (L.cloudsLoaded) { return; } L.cloudsLoaded = true;
  var q = L.q, qa = L.qa, MOTION = L.MOTION, IMG = L.assetBase || '';
  var motionOff = L.motionOff;
  function bootClouds() {
    var wraps = L.off && L.off.clouds ? [] : qa('[data-clouds]');
    function onLoad(fn) { if (document.readyState === 'complete') { window.setTimeout(fn, 0); } else { window.addEventListener('load', fn); } }
    if (!wraps.length) { return; }
    var SRCSET = L.cloud && L.cloud.srcset ? L.cloud.srcset : '' + IMG + 'sky-cloud-mid-1-400-c.webp 400w, ' + IMG + 'sky-cloud-mid-1-540-c.webp 540w, ' + IMG + 'sky-cloud-mid-1-800-c.webp 800w';
    var SIZES = '(max-width: 767px) 135px, 520px';
    var AR = 697 / 1255;
    /* n: copies [desktop, phone]; w: width in vw; o: opacity; v: drift in px/s; par: scroll parallax;
       y: band for the cloud's top edge, as a share of the section height (back high, front at the bottom edge). */
    var LAYERS = [
      { k: 'back',  n: [3, 1], w: [18, 27],  o: [0.85, 0.95], v: [6, 9],   par: 0.10, y: [0.10, 0.30] },
      { k: 'mid',   n: [2, 1], w: [32, 42],  o: [1, 1],       v: [12, 16], par: 0.25, y: [0.32, 0.58] },
      { k: 'front', n: [1, 0], w: [60, 78],  o: [1, 1],       v: [20, 26], par: 0.45, y: [0.74, 0.84] }
    ];
    var SECTION = {
      final: { y: { back: [0.08, 0.2], mid: [0.25, 0.45] } },
      stats:    { n: { back: [1, 0], mid: [1, 1], front: [0, 0] }, y: { back: [0.05, 0.2], mid: [0.55, 0.7] } },
      timeline: { n: { back: [1, 1], mid: [1, 0], front: [0, 0] }, y: { back: [0.1, 0.25], mid: [0.6, 0.75] } },
      kids:     { n: { back: [1, 0], mid: [1, 1], front: [0, 0] }, y: { back: [0.6, 0.75], mid: [0.05, 0.2] } },
      social:   { n: { back: [1, 1], mid: [1, 0], front: [0, 0] }, y: { back: [0.05, 0.2], mid: [0.55, 0.7] } },
      compare:  { n: { back: [1, 0], mid: [1, 1], front: [0, 0] }, y: { back: [0.45, 0.6], mid: [0.08, 0.25] } },
      faq:      { n: { back: [1, 1], mid: [1, 0], front: [0, 0] }, y: { back: [0.1, 0.25], mid: [0.55, 0.7] } },
      footer:   { n: { back: [2, 1], mid: [0, 0], front: [0, 0] }, y: { back: [0.0, 0.05] } },
      hero:     { lane: 0.14 }
    };
    var CFG = { speed: 0.2, parallax: 1.5, breathe: true, count: 4 };
    var LAYOUT = L.cloudLayout || {};
    var phone = window.matchMedia('(max-width: 767px)');
    var header = q('.header__inner');
    var PARALLAX = !!(window.CSS && CSS.supports && CSS.supports('animation-timeline: scroll()'));

    function rng(seed) {
      return function () {
        seed = (seed + 0x6D2B79F5) | 0;
        var t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
        t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
      };
    }
    function hash(s) { var h = 2166136261; for (var i = 0; i < s.length; i++) { h = Math.imul(h ^ s.charCodeAt(i), 16777619); } return h; }
    function lerp(a, b, t) { return a + (b - a) * t; }
    function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }

    var sections = wraps.map(function (wrap) {
      var name = wrap.getAttribute('data-clouds');
      var root = wrap.closest('section') || wrap.parentNode;
      return { wrap: wrap, name: name, root: root, cfg: SECTION[name] || {}, clouds: [], texts: qa('[data-sky-text]', root), hero: name === 'hero', W: 0, H: 0, frozen: false, css: '', range: '' };
    });

    /* One <style> holds every cloud's keyframes (rewritten on resize). */
    var sheet = document.createElement('style'); sheet.setAttribute('data-cloud-keyframes', ''); document.head.appendChild(sheet);

    var mode = null, loaded = false, waiting = [], started = false;
    function build() {
      var m = phone.matches ? 1 : 0;
      if (m === mode) { return; }
      mode = m;
      sections.forEach(function (s) {
        s.wrap.textContent = '';
        s.clouds = [];
        var r = rng(hash(s.name + m)), idx = 0, lastFlip = 1;
        var man = LAYOUT[s.name] && LAYOUT[s.name][m ? 'p' : 'd'];
        if (man) { man.forEach(function (d) { addManual(s, d, m); }); return; }
        LAYERS.forEach(function (Lr, li) {
          var n = ((s.cfg.n && s.cfg.n[Lr.k]) || Lr.n)[m];
          var band = (s.cfg.y && s.cfg.y[Lr.k]) || Lr.y;
          for (var i = 0; i < n; i++) {
            var eager = s.hero && idx === 0;
            var el = cloudImg(eager);
            el.className = 'sky-cloud sky-cloud--' + Lr.k;
            el.setAttribute('aria-hidden', 'true');
            var flip = idx === 0 ? (r() < 0.5 ? -1 : 1) : -lastFlip;
            lastFlip = flip;
            var c = {
              el: el, L: Lr, li: li, idx: idx,
              w: lerp(Lr.w[0], Lr.w[1], r()) * (s.hero && m === 0 && (idx === 1 || idx === 3) ? 0.72 : 1),
              op: lerp(Lr.o[0], Lr.o[1], r()) * (s.hero && m === 0 && (idx === 1 || idx === 3) ? 0.85 : 1), v: lerp(Lr.v[0], Lr.v[1], r()),
              y0: lerp(band[0], band[1], r()), x0: (i + 0.15 + r() * 0.7) / Math.max(1, n) + li * 0.21,
              rot: (r() * 2 - 1) * 3, flip: flip, side: s.hero ? (m === 0 && (idx === 1 || idx === 3) ? -1 : 1) : (idx % 2 ? 1 : -1),
              p1: 8000 + r() * 6000, p2: 9500 + r() * 7000, ph1: r() * 6.28, ph2: r() * 6.28
            };
            if (idx >= CFG.count) { el.style.display = 'none'; c.off = true; }
            s.clouds.push(c);
            mount(s, c);
            idx += 1;
          }
        });
      });
      measure();
    }
    function addManual(s, d, m) {
      var Lr = d.w < 30 ? LAYERS[0] : d.w < 55 ? LAYERS[1] : LAYERS[2], idx = s.clouds.length, r = rng(hash(s.name + m + idx));
      var el = cloudImg(false);
      el.className = 'sky-cloud sky-cloud--' + Lr.k;
      el.setAttribute('aria-hidden', 'true');
      var c = { el: el, L: Lr, li: LAYERS.indexOf(Lr), idx: idx, man: true, d: d,
        w: d.w, op: d.o == null ? 1 : d.o, v: lerp(Lr.v[0], Lr.v[1], r()), rot: 0, flip: d.f || 1,
        p1: 8000 + r() * 6000, p2: 9500 + r() * 7000, ph1: r() * 6.28, ph2: r() * 6.28 };
      s.clouds.push(c); mount(s, c);
      return c;
    }
    /* Each cloud sits in a parallax wrapper (a scroll-driven animation where supported; a plain box elsewhere). */
    function mount(s, c) {
      var par = document.createElement('div');
      par.className = 'sky-cloud-par sky-cloud-par--' + c.L.k;
      par.appendChild(c.el); c.par = par;
      s.wrap.appendChild(par);
    }
    function setSrc(img) {
      img.loading = 'eager'; img.setAttribute('fetchpriority', 'low'); img.sizes = SIZES; img.srcset = SRCSET;
      img.src = L.cloud && L.cloud.src ? L.cloud.src : '' + IMG + 'sky-cloud-mid-1-800-c.webp';
      if (L.cloud && L.cloud.src && !L.cloud.builtin) { img.classList.add('sky-cloud--custom'); }
      if (img.decode) { img.decode().catch(function () {}); }
    }
    function cloudImg(eager) {
      var img = document.createElement('img');
      img.alt = ''; img.decoding = 'async'; img.width = 1255; img.height = 697;
      /* Invisible until its picture is there (no empty box), then the CSS animation shows it. */
      img.addEventListener('load', function () { img.classList.add('is-ready'); });
      if (!eager) { img.loading = 'lazy'; }
      if (!loaded) { waiting.push(img); } else { setSrc(img); }
      return img;
    }
    /* No cloud requests its picture before the page's load event (+500 ms). */
    onLoad(function () { window.setTimeout(function () { loaded = true; waiting.splice(0).forEach(setSrc); start(); }, document.readyState === 'complete' ? 0 : 500); });

    /* Positions, sizes, text zones and the header box: measured on load, fonts, a width change, and for a section whose
       own height changed (ResizeObserver: an image or a section that renders late). All reads first, then the writes
       (the cloud's static styles, its keyframes, the parallax range). Everything is in px from the section's top and
       the parallax runs on the page's scroll position, so a section that grows or moves does not move its clouds.
       A section with tabs (FAQ) is frozen from its first tab toggle: its clouds are never re-placed after that, until
       the screen width changes. `only` limits the work to some sections; the others keep their last result. */
    var VH = window.innerHeight, lastCss = '';
    function measure(only) {
      var vw = window.innerWidth / 100, dpr = window.devicePixelRatio || 1, sy = window.pageYOffset;
      VH = window.innerHeight;
      var hr = header ? header.getBoundingClientRect() : null;
      var todo = sections.filter(function (s) { return !s.frozen && (!only || only.indexOf(s) >= 0); });
      var reads = todo.map(function (s) {
        var wr = s.wrap.getBoundingClientRect();
        var zones = s.texts.map(function (el) { var r = el.getBoundingClientRect(); return [r.left - wr.left - 24, r.top - wr.top - 24, r.right - wr.left + 24, r.bottom - wr.top + 24, 0.55]; })
          .filter(function (z) { return z[2] - z[0] > 48; });
        if (hr) { zones.push([hr.left - wr.left, hr.top - wr.top - 8, hr.right - wr.left, hr.bottom - wr.top + 8, 0.35]); }
        return { W: s.wrap.clientWidth, H: s.wrap.clientHeight, top: wr.top + sy, zones: zones };
      });
      todo.forEach(function (s, i) {
        var d = reads[i]; s.W = d.W; s.H = d.H; s.zones = d.zones;
        var css = '';
        s.clouds.forEach(function (c) {
          if (c.off) { return; }
          c.cw = Math.round(c.w * vw); c.ch = Math.round(c.cw * AR);
          c.lw = Math.min(c.cw, Math.round(1255 / dpr)); c.lh = Math.round(c.lw * AR);
          c.k = c.cw / c.lw;
          css += place(s, c);
        });
        s.css = css;
        /* Parallax range on the page's scroll position: from the section's top at the bottom of the screen to its
           bottom at the top (the same span the old view timeline used), fixed in px. */
        var range = Math.round(d.top - VH) + 'px ' + Math.round(d.top + d.H) + 'px';
        if (range !== s.range) { s.wrap.style.setProperty('--sky-r0', Math.round(d.top - VH) + 'px'); s.wrap.style.setProperty('--sky-r1', Math.round(d.top + d.H) + 'px'); s.range = range; }
      });
      var all = sections.map(function (s) { return s.css; }).join('');
      if (all !== lastCss) { sheet.textContent = all; lastCss = all; }
    }
    /* The static styles and the keyframes of one cloud. Returns the CSS text for the keyframes. */
    function place(s, c) {
      var lo, hi, xc, y;
      if (c.man) { xc = c.d.x * s.W; lo = xc - 0.02 * s.W; hi = xc + 0.02 * s.W; y = c.d.y * s.H; }
      else {
        var l0 = -0.6 * c.cw, h0 = Math.max(l0, (s.cfg.lane || 0.3) * s.W - 0.85 * c.cw);
        if (c.side < 0) { lo = l0; hi = h0; } else { lo = s.W - c.cw - h0; hi = s.W - c.cw - l0; }
        xc = (lo + hi) / 2; y = c.y0 * s.H;
      }
      /* Opacity: capped over text zones and behind the header (at the cloud's resting spot), faded near the edges. */
      var op = c.op, bw = c.cw, bh = c.ch, target = op;
      if (!c.man) {
        s.zones.forEach(function (z) {
          var ix = Math.min(xc + bw, z[2]) - Math.max(xc, z[0]), iy = Math.min(y + bh, z[3]) - Math.max(y, z[1]);
          if (ix > 0 && iy > 0) { var cover = clamp((ix * iy) / Math.min(bw * bh, (z[2] - z[0]) * (z[3] - z[1])) * 4); target = Math.min(target, op - Math.max(0, op - z[4]) * cover); }
        });
      }
      var cy = y + bh / 2, eTop = clamp(cy / (0.07 * s.H)), eBot = clamp((s.H - cy) / (0.09 * s.H));
      target *= Math.min(eTop, eBot);
      c.base = Math.min(1, Math.max(0, target));
      var dx = (c.cw - c.lw) / 2, dy = (c.ch - c.lh) / 2;
      function tf(x, sc) { var ks = sc * c.k; return 'translate3d(' + (x + dx).toFixed(1) + 'px,' + (y + dy).toFixed(1) + 'px,0) rotate(' + c.rot.toFixed(2) + 'deg) scale(' + (ks * c.flip).toFixed(4) + ',' + ks.toFixed(4) + ')'; }
      /* The old engine: swing = 0.5 + 0.5 sin(0.2 t v/60 drift + ph1) -> a full period of 1885/(v drift) s; the keyframes
         cover one half (lo -> hi, sine-eased, so the turnarounds are soft) and alternate. Breathing (+-3 % scale,
         +-0.06 opacity, periods of several minutes) rides along, sampled at the same points. */
      var drift = s.cfg.drift || 1, P = 1885 / (c.v * drift), half = P / 2, N = 12, kf = [];
      for (var k = 0; k <= N; k++) {
        var u = k / N, t = u * half, ang = -Math.PI / 2 + Math.PI * u;
        var swing = 0.5 + 0.5 * Math.sin(ang), x = lo + (hi - lo) * swing;
        var sc = 1, o = c.base;
        if (CFG.breathe) {
          sc += 0.03 * Math.sin(2 * Math.PI * t * 1000 / (31.4 * c.p1) + c.ph1);
          o = Math.min(1, Math.max(0, c.base + 0.06 * Math.sin(2 * Math.PI * t * 1000 / (31.4 * c.p2) + c.ph2)));
        }
        kf.push((u * 100).toFixed(2) + '%{transform:' + tf(x, sc) + ';opacity:' + o.toFixed(3) + '}');
      }
      var name = 'lc-' + s.name + '-' + c.idx + '-' + mode;
      var delay = -(c.ph1 / 6.2832) * P;
      var st = { width: c.lw + 'px', transform: tf(xc, 1), op: c.base.toFixed(3), anim: motionOff() ? 'none' : name + ' ' + half.toFixed(1) + 's linear infinite alternate ' + delay.toFixed(1) + 's' };
      if (!c.st || c.st.width !== st.width) { c.el.style.width = st.width; }
      if (!c.st || c.st.transform !== st.transform) { c.el.style.transform = st.transform; }
      if (!c.st || c.st.op !== st.op) { c.el.style.setProperty('--cloud-opacity', st.op); }
      if (!c.st || c.st.anim !== st.anim) { c.el.style.animation = st.anim; }
      c.st = st;
      /* Hero clouds slide in from 40px aside and fade, 1.2 s, 120 ms per layer, once their pictures are ready. */
      if (!c.inSet) { c.par.style.setProperty('--cloud-in-delay', (c.li * 120) + 'ms'); c.par.style.setProperty('--cloud-in-dx', (c.side < 0 ? -40 : 40) + 'px'); c.inSet = true; }
      /* Parallax: +-0.75 x par x section height over the section's pass through the screen (CSS, scroll-driven), in px. */
      var parPx = (0.75 * c.L.par * CFG.parallax * s.H).toFixed(1) + 'px';
      if (c.parPx !== parPx) { c.par.style.setProperty('--cloud-par', parPx); c.parPx = parPx; }
      return '@keyframes ' + name + '{' + kf.join('') + '}';
    }
    function start() { if (started) { return; } started = true; sections.forEach(function (s) { if (s.hero) { s.wrap.classList.add('is-in'); } }); }

    build();
    if (loaded) { start(); }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var s = sections.filter(function (x) { return x.wrap === e.target; })[0];
        if (s && !motionOff()) { s.wrap.classList.toggle('is-idle', !e.isIntersecting); }
      });
    }, { rootMargin: '200px 0px' });
    sections.forEach(function (s) { io.observe(s.wrap); });
    MOTION.addEventListener('change', function () { measure(); });
    /* Only a width change re-places clouds (a phone's address bar showing or hiding changes the height only). */
    var lastW = window.innerWidth;
    window.addEventListener('resize', function () { if (window.innerWidth === lastW) { return; } lastW = window.innerWidth; sections.forEach(function (s) { s.frozen = false; }); build(); measure(); });
    onLoad(function () { measure(); });
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(function () { measure(); }); }
    /* A tab opening or closing (FAQ, product details) freezes its section's clouds where they are. */
    document.addEventListener('lagom:tab', function (e) { sections.forEach(function (s) { if (s.root.contains(e.target)) { s.frozen = true; } }); }, true);
    /* A section whose own height changed for another reason (late images, a section rendering late) is re-placed. */
    if (window.ResizeObserver) {
      var roPending = [], roRaf = 0;
      var ro = new ResizeObserver(function (entries) {
        entries.forEach(function (en) { var s = sections.filter(function (x) { return x.wrap === en.target; })[0]; if (s && !s.frozen && Math.abs(s.wrap.clientHeight - s.H) > 1 && roPending.indexOf(s) < 0) { roPending.push(s); } });
        /* The sections after it moved too: their scroll ranges follow (a frozen tab section never triggers this). */
        if (roPending.length && !roRaf) { roRaf = window.requestAnimationFrame(function () { roRaf = 0; var list = roPending.splice(0), first = Math.min.apply(null, list.map(function (x) { return sections.indexOf(x); })); measure(sections.filter(function (x, i) { return i >= first; })); }); }
      });
      sections.forEach(function (s) { ro.observe(s.wrap); });
    }
    document.documentElement.classList.toggle('has-cloud-parallax', PARALLAX);
  }
  (function () {
    var done = false; function go() { if (done) { return; } done = true; bootClouds(); }
    var idle = window.requestIdleCallback ? function (f) { window.requestIdleCallback(f, { timeout: 1500 }); } : function (f) { window.setTimeout(f, 1); };
    if (document.readyState === 'complete') { idle(go); } else { window.addEventListener('load', function () { idle(go); }); window.setTimeout(go, 2500); }
  })();
})();
